import {XauditModel} from '../xaudit.model';

export class DoctorLocationDataModel extends XauditModel {
  DoctorId: string;
  LOCID: number;
  enumWeekDaysId: string;
}


export class DoctorRefLocationDataModel extends XauditModel {
  RefDoctorId: string;
  DoctorId: string;
  LOCID: number;
  isSeleted: boolean;
  locDescription: string;
}
